<template>
  <div id="container">
    <menu-vertical
      class="menu"
      :explicacion="pathModulo.explicacion"
      :demostracion="pathModulo.demostracion"
      :actividad="pathModulo.actividad"
      :cuestionario="pathModulo.cuestionario"
    ></menu-vertical>
    <user-image :puntaje="puntaje" :img="imageUser"></user-image>
    <!-- <barra-herramientas /> -->
    <div class="point point-0">
      <div class="label">(2.5,-1,0)</div>
      <div class="text">
        El objeto esta ubicado en la coordenada (2.5,-1,0) que corresponde a 2.5
        posiciones en el eje X, -1 posiciones en el eje Y y 0 posiciones en el
        eje Z.
      </div>
    </div>
    <div class="point point-1">
      <div class="label">(4,4,4)</div>
      <div class="text">
        El objeto esta ubicado en la coordenada (4,4,4) que corresponde a 4
        posiciones en el eje X, 4 posiciones en el eje Y y 4 posiciones en el
        eje Z.
      </div>
    </div>
    <div class="point point-2">
      <div class="label">(-4,-3,-4)</div>
      <div class="text">
        El objeto esta ubicado en la coordenada (-4,-3,-4) que corresponde a -4
        posiciones en el eje X, -3 posiciones en el eje Y y -4 posiciones en el
        eje Z.
      </div>
    </div>
    <div class="point point-3">
      <div class="label">(-1.5,3,0)</div>
      <div class="text">
        El objeto esta ubicado en la coordenada (-1.5,3,0) que corresponde a
        -1.5 posiciones en el eje X, 3 posiciones en el eje Y y 0 posiciones en
        el eje Z.
      </div>
    </div>
    <div class="point point-4">
      <div class="label">(-3,0,1)</div>
      <div class="text">
        El objeto esta ubicado en la coordenada (-3,0,1) que corresponde a -3
        posiciones en el eje X, 0 posiciones en el eje Y y 1 posiciones en el
        eje Z.
      </div>
    </div>

    <div v-if="felicidades" class="felicidades">
      <img src="@/assets/img/icons3D/construct.png" alt="column" />
      <h2>¡FELICITACIONES!</h2>
      <p>
        Acabas de obtener tu segundo logro, por finalizar la Demostacion de
        <b> Sistemas de Coordenadas 3D</b>.
      </p>
      <router-link class="botonLogro" to="/actividad-sistema-de-coordenadas"
        >Continuar</router-link
      >
    </div>
    <!-- <router-link to="/actividad-sistema-de-coordenadas">Actividad</router-link> -->
    <a class="botonActividad" @click="logro()">Actividad</a>
  </div>
</template>
<script>
import MenuVertical from "@/components/MenuVertical.vue";
import * as Three from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry.js";
import { TWEEN } from "three/examples/jsm/libs/tween.module.min";
import { FontLoader } from "three/examples/jsm/loaders/FontLoader.js";
// import BarraHerramientas from "@/components/BarraHerramientas.vue";
import UserImage from "../../components/UserImage.vue";
export default {
  name: "DemostacionSistemaCoordenadas",
  components: {
    MenuVertical,
    UserImage,
  },
  data() {
    return {
      puntaje: 0,
      felicidades: false,
      cont: 1,
      sphereU: null,
      textMesh1: null,
      axisZ: null,
      axisZr: null,
      cylinderZ: null,
      group: null,
      siguiente: false,
      camera: null,
      scene: null,
      renderer: null,
      gridHelper: null,
      gridHelperZX: null,
      gridHelperYZ: null,
      anim: null,
      raycaster: null,
      points: [],
      sphere: null,
      textMesh: null,
      textMeshY: null,
      textMeshZ: null,
      axisXCoor: null,
      axisZCoor: null,
      axisYCoor: null,
      decodeToken: null,
      imageUser:
        "https://cdn.pixabay.com/photo/2018/04/18/18/56/user-3331256__340.png",
      logros: [],
      pathModulo: {
        explicacion: "/sistema-de-coordenadas",
        demostracion: "/demostracion-sistema-de-coordenadas",
        actividad: "/actividad-sistema-de-coordenadas",
        cuestionario: "/cuestionario-sistema-de-coordenadas",
      },
    };
  },
  methods: {
    init: function () {
      let container = document.getElementById("container");
      this.camera = new Three.PerspectiveCamera(
        45,
        window.innerWidth / window.innerHeight,
        0.01,
        2000
      );
      this.camera.position.z = 16;
      this.camera.position.y = 10;
      this.scene = new Three.Scene();
      this.scene.rotation.x = -Math.PI / 2;
      const size = 10;
      const divisions = 10;

      const geometry = new Three.PlaneGeometry(size, divisions);
      const material = new Three.MeshBasicMaterial({
        color: 0x0000ff,
        opacity: 0.5,
        transparent: true,
        side: Three.DoubleSide,
      });
      const materialRojo = new Three.MeshBasicMaterial({
        color: 0xff0000,
        opacity: 0.5,
        transparent: true,
        side: Three.DoubleSide,
      });
      const materialVerde = new Three.MeshBasicMaterial({
        color: 0x00ff00,
        opacity: 0.5,
        transparent: true,
        side: Three.DoubleSide,
      });
      const helperx = new Three.GridHelper(size, divisions);
      const helpery = new Three.GridHelper(size, divisions);
      const helperz = new Three.GridHelper(size, divisions);
      helpery.rotation.x = Math.PI / 2;
      helperz.rotation.z = Math.PI / 2;
      this.gridHelper = new Three.Mesh(geometry, materialVerde);
      this.gridHelper = new Three.Mesh(geometry, materialVerde);
      this.gridHelper = new Three.Mesh(geometry, materialVerde);
      this.gridHelper.rotation.y = Math.PI / 2;
      this.gridHelper.position.y = 0;

      this.gridHelperYZ = new Three.Mesh(geometry, material);
      //   this.gridHel
      this.gridHelperYZ.rotation.x = Math.PI / 2;
      this.gridHelperYZ.position.y = 0;
      this.gridHelperZX = new Three.Mesh(geometry, materialRojo);
      this.gridHelperZX.rotation.z = Math.PI / 2;
      this.gridHelperZX.position.y = 0;

      this.renderer = new Three.WebGLRenderer({ antialias: true });
      //   this.renderer.setClearColor(0xffffff);
      this.renderer.setSize(container.clientWidth, container.clientHeight);
      container.appendChild(this.renderer.domElement);
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);

      this.controls.update(); //must be called after any manual changes to the camera's transform
      //   this.controls.enablePan = false;
      //   this.controls.minAzimuthAngle = 0; // radians
      //   this.controls.maxAzimuthAngle = 0;

      let maxX = 2;
      let axisXLength = maxX * 2;
      const axisXHeadLength = axisXLength * 0.25;
      const axisXHeadWidth = axisXHeadLength * 1;
      const directionX = new Three.Vector3(1, 0, 0);
      const directionXr = new Three.Vector3(-1, 0, 0);
      const startX = new Three.Vector3(-maxX, 0, 0);
      const colorX = 0xff0000;
      const axisX = new Three.ArrowHelper(
        directionX,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      const axisXr = new Three.ArrowHelper(
        directionXr,
        startX,
        axisXLength + axisXHeadLength * 2,
        colorX,
        axisXHeadLength,
        axisXHeadWidth
      );
      axisX.position.x = 0;
      axisX.position.y = 0;
      axisX.position.z = 0;
      axisXr.position.x = 0;
      axisXr.position.y = 0;
      axisXr.position.z = 0;

      const geometryX = new Three.CylinderGeometry(0.1, 0.1, 10, 32);
      const materialX = new Three.MeshPhongMaterial({ color: colorX });
      const cylinder = new Three.Mesh(geometryX, materialX);
      cylinder.rotation.z = Math.PI / 2;
      cylinder.position.x = 0;
      cylinder.position.y = 0;
      cylinder.position.z = 0;

      let axisYLength = maxX * 2;
      const axisYHeadLength = axisYLength * 0.25;
      const axisYHeadWidth = axisYHeadLength;
      const directionY = new Three.Vector3(0, 1, 0);
      const directionYr = new Three.Vector3(0, -1, 0);
      const startY = new Three.Vector3(0, maxX, 0);
      const colorY = 0x00ff00;
      const axisY = new Three.ArrowHelper(
        directionY,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      const axisYr = new Three.ArrowHelper(
        directionYr,
        startY,
        axisYLength + axisYHeadLength * 2,
        colorY,
        axisYHeadLength,
        axisYHeadWidth
      );
      axisY.position.x = 0;
      axisY.position.y = 0;
      axisY.position.z = 0;
      axisYr.position.x = 0;
      axisYr.position.y = 0;
      axisYr.position.z = 0;

      const materialY = new Three.MeshPhongMaterial({ color: colorY });
      const cylinderY = new Three.Mesh(geometryX, materialY);
      cylinderY.rotation.y = Math.PI / 2;
      cylinderY.position.x = 0;
      cylinderY.position.y = 0;
      cylinderY.position.z = 0;

      this.group = new Three.Group();

      const geometrySphe = new Three.SphereGeometry(0.5, 32, 16);
      const materialSPhe = new Three.MeshBasicMaterial({ color: 0xffff00 });
      this.sphere = new Three.Mesh(geometrySphe, materialSPhe);
      this.sphere.position.x = 3;
      this.sphere.position.y = 3;
      this.sphere.position.z = 3;
      this.group.add(this.sphere);

      let sphere2 = new Three.Mesh(geometrySphe, materialSPhe);
      sphere2.position.x = -1;
      sphere2.position.y = 2.5;
      sphere2.position.z = 0;
      this.group.add(sphere2);

      let sphere3 = new Three.Mesh(geometrySphe, materialSPhe);
      sphere3.position.x = -3;
      sphere3.position.y = 0;
      sphere3.position.z = 1;
      this.group.add(sphere3);
      let sphere4 = new Three.Mesh(geometrySphe, materialSPhe);
      sphere4.position.x = 2;
      sphere4.position.y = -0.5;
      sphere4.position.z = 0;
      this.group.add(sphere4);
      let sphere5 = new Three.Mesh(geometrySphe, materialSPhe);
      sphere5.position.x = -3;
      sphere5.position.y = -2;
      sphere5.position.z = -3;
      this.group.add(sphere5);

      let axisZLength = maxX * 2;
      const axisZHeadLength = axisZLength * 0.25;
      const axisZHeadWidth = axisZHeadLength;
      const directionZ = new Three.Vector3(0, 0, 1);
      const startZ = new Three.Vector3(0, 0, maxX);
      const colorZ = 0x0000ff;
      this.axisZ = new Three.ArrowHelper(
        directionZ,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );

      const directionZr = new Three.Vector3(0, 0, -1);

      this.axisZr = new Three.ArrowHelper(
        directionZr,
        startZ,
        axisZLength + axisZHeadLength * 2,
        colorZ,
        axisZHeadLength,
        axisZHeadWidth
      );
      this.axisZr.position.x = 0;
      this.axisZr.position.y = 0;
      this.axisZr.position.z = 0;
      this.axisZ.position.x = 0;
      this.axisZ.position.y = 0;
      this.axisZ.position.z = 0;

      const materialZ = new Three.MeshPhongMaterial({ color: colorZ });
      this.cylinderZ = new Three.Mesh(geometryX, materialZ);
      this.cylinderZ.rotation.x = Math.PI / 2;
      this.cylinderZ.position.x = 0;
      this.cylinderZ.position.y = 0;
      this.cylinderZ.position.z = 0;

      this.group.add(cylinderY);
      this.group.add(axisY);
      this.group.add(cylinder);
      this.group.add(axisX);
      this.group.add(axisYr);
      this.group.add(axisXr);
      this.group.add(helperx);
      this.group.add(helpery);
      this.group.add(helperz);
      this.group.rotation.x = 0;
      const light = new Three.AmbientLight(0xffffff, 0.5); // soft white light
      this.scene.add(light);
      const directionalLight = new Three.DirectionalLight(0xffffff);
      directionalLight.position.set(1, 1.75, 1.5).normalize();
      this.scene.add(directionalLight);

      const loader = new FontLoader();

      loader.load(
        "fonts/helvetiker_regular.typeface.json",
        (font) => {
          // console.log(font);
          let textoGeo = new TextGeometry("X", {
            font: font,
            size: 0.5,
            height: 0.1,
          });
          let textoGeoY = new TextGeometry("Y", {
            font: font,
            size: 0.5,
            height: 0.1,
          });
          let textoGeoZ = new TextGeometry("Z", {
            font: font,
            size: 0.5,
            height: 0.1,
          });
          let materials = new Three.MeshPhongMaterial({
            color: 0xffffff,
            // flatShading: true,
          });
          this.textMesh = new Three.Mesh(textoGeo, materials);
          this.textMeshY = new Three.Mesh(textoGeoY, materials);
          this.textMeshZ = new Three.Mesh(textoGeoZ, materials);

          this.textMesh.position.x = 6.5;
          this.textMesh.position.y = -0.25;
          this.textMesh.position.z = -0.25;
          this.textMesh.rotation.x = Math.PI / 2;
          this.textMesh.rotation.y = Math.PI;

          this.textMeshY.position.y = 6.5;
          this.textMeshY.position.x = 0.25;
          this.textMeshY.position.z = 0.25;
          this.textMeshY.rotation.x = Math.PI / 2;
          this.textMeshY.rotation.y = Math.PI;

          this.textMeshZ.position.y = 0.25;
          this.textMeshZ.position.x = 0.25;
          this.textMeshZ.position.z = 6.5;
          this.textMeshZ.rotation.x = Math.PI / 2;
          this.textMeshZ.rotation.y = Math.PI;
        },
        // Progreso de carga
        function (xhr) {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        // se produjo un error
        function (err) {
          console.log(err);
        }
      );

      this.group.add(this.cylinderZ);
      this.group.add(this.axisZr);
      this.group.add(this.axisZ);
      this.group.rotation.z = Math.PI / 5;
      this.group.add(this.gridHelper);
      this.group.add(this.gridHelperZX);
      this.group.add(this.gridHelperYZ);
      this.scene.add(this.group);
      //   this.scene.position.z = -3;
      //   this.group.scale.set(0.7, 0.7, 0.7);

      /**
       * Points of interest
       */
      this.raycaster = new Three.Raycaster();

      this.points = [
        {
          position: new Three.Vector3(1.55, 0.3, -0.6),
          element: document.querySelector(".point-0"),
        },
        {
          position: new Three.Vector3(0.2, 3, -4),
          element: document.querySelector(".point-1"),
        },
        {
          position: new Three.Vector3(-1.6, -3, 3.7),
          element: document.querySelector(".point-2"),
        },
        {
          position: new Three.Vector3(-2.35, -0.5, -1.05),
          element: document.querySelector(".point-3"),
        },
        {
          position: new Three.Vector3(-2.215, 1.04, 1.43),
          element: document.querySelector(".point-4"),
        },
      ];
    },
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();

      this.renderer.setSize(window.innerWidth, window.innerHeight);
    },
    animate: function () {
      requestAnimationFrame(this.animate);
      TWEEN.update();
      this.renderer.render(this.scene, this.camera);
      if (
        this.$router.history.current.path ==
        "/demostracion-sistema-de-coordenadas"
      ) {
        if (this.textMesh) {
          this.group.add(this.textMesh);
          this.group.add(this.textMeshY);
          this.group.add(this.textMeshZ);

          // Got through each point
          for (const point of this.points) {
            // console.log(point);
            const screenPosition = point.position.clone();
            screenPosition.project(this.camera);

            this.raycaster.setFromCamera(screenPosition, this.camera);
            // const intersects = this.raycaster.intersectObjects(
            //   this.scene.children,
            //   true
            // );
            point.element.classList.add("visible");

            // if (intersects.length === 0) {
            // } else {
            //   const intersectionDistance = intersects[0].distance;
            //   const pointDistance = point.position.distanceTo(
            //     this.camera.position
            //   );

            //   if (intersectionDistance < pointDistance) {
            //     point.element.classList.remove("visible");
            //   } else {
            //     point.element.classList.add("visible");
            //   }
            // }
            // console.log(translateX);
            const translateX = screenPosition.x * window.innerWidth * 0.5;
            const translateY = -screenPosition.y * window.innerHeight * 0.5;

            point.element.style.transform = `translate(${translateX}px, ${translateY}px)`;
          }
          window.addEventListener("resize", this.onWindowResize);
        }
      }
    },
    profile() {
      this.decodeToken = this.$getDataProfile(
        localStorage.getItem("token")
      ).uid;

      var axios = require("axios");

      var config = {
        method: "get",
        url: `https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`,
        headers: {},
      };

      axios(config)
        .then((response) => {
          console.log(response.data);
          this.imageUser = response.data.img;
          this.logros = response.data.logros;
          this.puntaje = response.data.puntaje;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    logro() {
      this.felicidades = true;
      if (this.logros.indexOf("DemostracionSistemaCoordenadas") != -1) {
        console.log("ya tiene este logro");
      } else {
        this.puntaje += 10;
        this.logros.push("DemostracionSistemaCoordenadas");
        fetch(`https://restserver-cg.onrender.com/api/usuarios/${this.decodeToken}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: `{"logros":${JSON.stringify(this.logros)},"puntaje":${
            this.puntaje
          }}`,
        })
          .then((response) => {
            console.log(response);
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
  },
  mounted() {
    this.profile();
    this.init();
    this.animate();
  },
};
</script>
<style scoped>
#container {
  height: 100vh;
  width: 100vw;
  background: #fff;
}
.menu {
  position: absolute;
} /* Points of interest */
.point {
  position: absolute;
  top: 50%;
  left: 50%;

  --point-color: #513bed96;
}

.point .label {
  position: absolute;
  top: -20px;
  left: -20px;
  width: fit-content;
  padding: 0.1rem 0.5rem;
  height: 40px;
  border-radius: 5px;
  background-color: #00000077;
  color: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border: 1px solid #ffffff77;
  text-align: center;
  line-height: 40px;
  font-weight: bold;
  transition: background-color 0.3s ease-out, transform 0.3s ease-out;
  will-change: background-color, transform;
  cursor: help;
  transform: scale(0);
}

.point.visible .label {
  transform: scale(1);
}

.point .label:hover {
  background-color: var(--point-color);
  /* border-color: var(--point-color); */
}

.point .label:hover + .text {
  opacity: 1;
  transform: translateY(0);
}

.point .text {
  position: absolute;
  top: 30px;
  left: calc(-100px - 1em);
  width: 200px;
  background-color: #00000084;
  color: #ffffff;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.4;
  font-size: 1rem;
  padding: 1em 1.4em;
  border-radius: 4px;
  box-shadow: -2px 0 0 0 var(--point-color), 2px 0 0 0 var(--point-color);
  opacity: 0;
  transform: translateY(-10px);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  will-change: opacity, transition;
  pointer-events: none;
}
.botonActividad {
  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  /* right: calc(40%-var(--espacio)); */
  right: 2rem;
  top: 30rem;
  padding: 1rem;
}
.felicidades {
  position: absolute;
  background: white;
  border-radius: 10px;
  width: 40%;
  height: fit-content;
  /* height: 50%; */
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  font-family: "Exo 2", sans-serif !important;
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.felicidades h2 {
  position: relative;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 1rem;
  padding: 0.5rem;
  font-family: "Exo 2", sans-serif !important;
  color: black;
}
.felicidades p {
  color: black;
  /* font-weight: bold; */
  font-family: "Exo 2", sans-serif !important;
  font-size: 1rem;
  margin-bottom: 1rem;
  padding: 0 1.5rem;
}
.felicidades img {
  margin: 1rem;
  width: 35%;
}
.botonLogro {
  position: relative;

  font-size: 1.2rem;
  width: var(--espacio);
  padding: 0.8rem 1rem;
  border-radius: 6px;
  font-family: "Exo 2", sans-serif;
  background: #ffc300;
  font-weight: bold;
  cursor: pointer;
  padding: 1rem;
  margin: 1rem;
}
</style>
